/* MAD LEATHER — product page behaviours (vanilla, no dependencies) */
(function () {
  'use strict';

  var root = document.querySelector('[data-ml-pdp]');
  if (!root) return;

  var $ = function (s, r) { return (r || root).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); };
  var on = function (el, ev, fn) { el && el.addEventListener(ev, fn); };

  var variants = [];
  try { variants = JSON.parse($('[data-ml-pdp-variants]').textContent); } catch (e) { variants = []; }

  var moneyFormat = root.dataset.moneyFormat || '₹{{amount}}';
  var money = function (cents) {
    return moneyFormat.replace(/\{\{\s*amount(_no_decimals)?(_with_comma_separator)?\s*\}\}/, function () {
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    });
  };

  /* ------------------------------------------------ gallery */
  var items = $$('[data-ml-media]');
  var thumbs = $$('[data-ml-thumb]');
  var counter = $('[data-ml-gallery-counter]');
  var index = 0;

  function pauseVideos() {
    $$('video').forEach(function (v) { if (!v.paused) v.pause(); });
  }

  function showMedia(i) {
    if (!items.length) return;
    index = (i + items.length) % items.length;
    pauseVideos();
    items.forEach(function (el, x) { el.classList.toggle('is-active', x === index); });
    thumbs.forEach(function (el, x) {
      el.classList.toggle('is-active', x === index);
      el.setAttribute('aria-selected', x === index ? 'true' : 'false');
    });
    if (counter) counter.textContent = (index + 1) + ' / ' + items.length;
  }

  thumbs.forEach(function (t, x) { on(t, 'click', function () { showMedia(x); }); });
  on($('[data-ml-gallery-prev]'), 'click', function () { showMedia(index - 1); });
  on($('[data-ml-gallery-next]'), 'click', function () { showMedia(index + 1); });

  var gallery = $('[data-ml-gallery]');
  if (gallery) {
    gallery.setAttribute('tabindex', '0');
    on(gallery, 'keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); showMedia(index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); showMedia(index - 1); }
    });
    // swipe
    var sx = null;
    on(gallery, 'touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    on(gallery, 'touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 45) showMedia(index + (dx < 0 ? 1 : -1));
      sx = null;
    });
  }

  /* ------------------------------------------------ lightbox */
  var lightbox = $('[data-ml-lightbox]');
  var lightboxImg = $('[data-ml-lightbox-image]');

  function zoomables() { return $$('[data-ml-zoomable]'); }

  function openLightbox(img) {
    if (!lightbox || !img) return;
    lightboxImg.src = img.dataset.full || img.src;
    lightboxImg.alt = img.alt || '';
    lightbox.hidden = false;
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.hidden = true;
    document.body.style.overflow = '';
  }
  function stepLightbox(dir) {
    var list = zoomables();
    if (!list.length) return;
    var current = list.indexOf($('.ml-gallery__item.is-active [data-ml-zoomable]'));
    var next = list[((current + dir) + list.length) % list.length];
    if (next) {
      var owner = next.closest('[data-ml-media]');
      if (owner) showMedia(parseInt(owner.dataset.index, 10));
      openLightbox(next);
    }
  }

  $$('[data-ml-lightbox-open]').forEach(function (b) {
    on(b, 'click', function () { openLightbox($('[data-ml-zoomable]', b.closest('[data-ml-media]'))); });
  });
  zoomables().forEach(function (img) { on(img, 'click', function () { openLightbox(img); }); });
  on($('[data-ml-lightbox-close]'), 'click', closeLightbox);
  on($('[data-ml-lightbox-prev]'), 'click', function () { stepLightbox(-1); });
  on($('[data-ml-lightbox-next]'), 'click', function () { stepLightbox(1); });
  on(lightbox, 'click', function (e) { if (e.target === lightbox) closeLightbox(); });
  on(document, 'keydown', function (e) {
    if (lightbox && lightbox.hidden) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowRight') stepLightbox(1);
    if (e.key === 'ArrowLeft') stepLightbox(-1);
  });

  /* ------------------------------------------------ variant selection */
  var idInput = $('[data-ml-variant-id]');
  var priceEl = $('[data-ml-price]');
  var compareEl = $('[data-ml-compare]');
  var saveEl = $('[data-ml-save]');
  var skuEl = $('[data-ml-sku]');
  var barcodeEl = $('[data-ml-barcode]');
  var stockEl = $('[data-ml-stock]');
  var atc = $('[data-ml-pdp-atc]');
  var atcLabel = $('[data-ml-atc-label]');
  var buynow = $('[data-ml-buynow]');
  var stickyPrice = $('[data-ml-sticky-price]');
  var stickyVariant = $('[data-ml-sticky-variant]');
  var stickyImage = $('[data-ml-sticky-image]');
  var stickyBtn = $('[data-ml-sticky-atc]');
  var stickyLabel = $('[data-ml-sticky-label]');

  function selection() {
    var out = [];
    $$('[data-ml-option]').forEach(function (group) {
      var checked = $('[data-ml-option-input]:checked', group);
      out[parseInt(group.dataset.optionPosition, 10) - 1] = checked ? checked.dataset.value : null;
    });
    return out;
  }

  function findVariant(sel) {
    return variants.filter(function (v) {
      return sel.every(function (val, i) { return val === null || v.options[i] === val; });
    })[0] || null;
  }

  function markAvailability(sel) {
    $$('[data-ml-option]').forEach(function (group) {
      var pos = parseInt(group.dataset.optionPosition, 10) - 1;
      $$('[data-ml-option-input]', group).forEach(function (input) {
        var test = sel.slice();
        test[pos] = input.dataset.value;
        var available = variants.some(function (v) {
          return v.available && test.every(function (val, i) { return val === null || v.options[i] === val; });
        });
        var label = input.closest('label');
        if (label) label.classList.toggle('is-unavailable', !available);
      });
    });
  }

  function render(pushUrl) {
    var sel = selection();
    var v = findVariant(sel);

    $$('[data-ml-option]').forEach(function (group) {
      var pos = parseInt(group.dataset.optionPosition, 10);
      var checked = $('[data-ml-option-input]:checked', group);
      $$('label', group).forEach(function (l) {
        l.classList.toggle('is-active', !!$('[data-ml-option-input]:checked', l));
      });
      var out = root.querySelector('[data-ml-option-value="' + pos + '"]');
      if (out && checked) out.textContent = checked.dataset.value;
    });

    markAvailability(sel);
    if (!v) {
      if (atc) atc.disabled = true;
      if (buynow) buynow.disabled = true;
      if (atcLabel) atcLabel.textContent = 'Unavailable';
      if (stockEl) stockEl.textContent = 'This combination is unavailable';
      return;
    }

    if (idInput) idInput.value = v.id;
    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      var hasCompare = v.compare_at_price && v.compare_at_price > v.price;
      compareEl.textContent = hasCompare ? money(v.compare_at_price) : '';
      compareEl.classList.toggle('ml-hidden', !hasCompare);
      if (saveEl) {
        saveEl.textContent = hasCompare ? 'Save ' + money(v.compare_at_price - v.price) : '';
        saveEl.classList.toggle('ml-hidden', !hasCompare);
      }
    }
    if (skuEl) skuEl.textContent = v.sku || '';
    if (barcodeEl) barcodeEl.textContent = v.barcode || '';
    if (stockEl) {
      if (!v.available) stockEl.textContent = 'Currently unavailable in this selection';
      else if (v.inventory_management && v.inventory_quantity > 0 && v.inventory_quantity <= 5) {
        stockEl.textContent = 'Low stock · ' + v.inventory_quantity + ' available';
      } else stockEl.textContent = 'In stock · ready to ship';
    }
    if (atc) atc.disabled = !v.available;
    if (buynow) buynow.disabled = !v.available;
    if (atcLabel) atcLabel.textContent = v.available ? 'Add to cart' : 'Sold out';

    if (stickyPrice) stickyPrice.textContent = money(v.price);
    if (stickyVariant) stickyVariant.textContent = v.title;
    if (stickyBtn) stickyBtn.disabled = !v.available;
    if (stickyLabel) stickyLabel.textContent = v.available ? 'Add' : 'Sold out';
    if (stickyImage && v.image) stickyImage.src = v.image;

    if (v.media_id) {
      var target = items.filter(function (el) { return el.dataset.mediaId === String(v.media_id); })[0];
      if (target) showMedia(parseInt(target.dataset.index, 10));
    }

    if (pushUrl && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
  }

  $$('[data-ml-option-input]').forEach(function (input) {
    on(input, 'change', function () { render(true); });
  });
  render(false);

  /* ------------------------------------------------ quantity */
  var qtyInput = $('[data-ml-qty-input]');
  on($('[data-ml-qty-down]'), 'click', function () {
    qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
  });
  on($('[data-ml-qty-up]'), 'click', function () {
    qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
  });

  /* ------------------------------------------------ add to cart */
  var form = $('form[action*="/cart/add"]') || $('.ml-pdp__form');

  function addToCart(button, label, doneText) {
    if (!idInput) return;
    var original = label ? label.textContent : '';
    button.classList.add('is-loading');
    if (label) label.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: parseInt(qtyInput ? qtyInput.value : 1, 10) || 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (label) label.textContent = doneText;
        var count = document.querySelector('[data-ml-cart-count]');
        if (count) count.textContent = String((parseInt(count.textContent, 10) || 0) + 1);
        setTimeout(function () {
          button.classList.remove('is-loading');
          if (label) label.textContent = original;
        }, 1600);
      })
      .catch(function () {
        button.classList.remove('is-loading');
        if (label) label.textContent = original;
      });
  }

  if (form && atc) {
    on(form, 'submit', function (e) {
      if (e.submitter && e.submitter.name === 'checkout') return; // let Buy it now go to checkout
      e.preventDefault();
      addToCart(atc, atcLabel, 'Added to cart');
    });
  }
  on(stickyBtn, 'click', function () { addToCart(stickyBtn, stickyLabel, 'Added'); });

  /* ------------------------------------------------ sticky bar visibility */
  var stickybar = $('[data-ml-stickybar]');
  if (stickybar && atc && 'IntersectionObserver' in window) {
    stickybar.hidden = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickybar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 }).observe(atc);
  }

  /* ------------------------------------------------ wishlist */
  var WISH = 'ml_wishlist';
  var wish = $('[data-ml-wishlist]');
  if (wish) {
    var handle = document.body.dataset.mlProductHandle;
    var read = function () { try { return JSON.parse(localStorage.getItem(WISH) || '[]'); } catch (e) { return []; } };
    var sync = function () { wish.classList.toggle('is-active', read().indexOf(handle) !== -1); };
    sync();
    on(wish, 'click', function () {
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) list.push(handle); else list.splice(i, 1);
      try { localStorage.setItem(WISH, JSON.stringify(list)); } catch (e) {}
      sync();
    });
  }

  /* ------------------------------------------------ review filter + sort */
  var reviewList = document.querySelector('[data-ml-review-list]');
  if (reviewList) {
    var reviews = Array.prototype.slice.call(reviewList.querySelectorAll('[data-ml-review]'));
    var chips = Array.prototype.slice.call(document.querySelectorAll('[data-ml-review-filter]'));
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        var val = chip.dataset.mlReviewFilter;
        chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
        reviews.forEach(function (rev) {
          rev.classList.toggle('ml-hidden', val !== 'all' && rev.dataset.rating !== val);
        });
      });
    });
    var sort = document.querySelector('[data-ml-review-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var mode = sort.value;
        reviews.slice().sort(function (a, b) {
          if (mode === 'high') return b.dataset.rating - a.dataset.rating;
          if (mode === 'low') return a.dataset.rating - b.dataset.rating;
          return a.dataset.order - b.dataset.order;
        }).forEach(function (rev) { reviewList.appendChild(rev); });
      });
    }
  }
})();
